export const UploadCsv = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        {...props}
        d="M12.0001 10.0003V12.0003H4.00008V10.0003H2.66675V12.0003C2.66675 12.7337 3.26675 13.3337 4.00008 13.3337H12.0001C12.7334 13.3337 13.3334 12.7337 13.3334 12.0003V10.0003H12.0001ZM4.66675 6.00033L5.60675 6.94033L7.33341 5.22033V10.667H8.66675V5.22033L10.3934 6.94033L11.3334 6.00033L8.00008 2.66699L4.66675 6.00033Z"
        fill={props.fill}
      />
    </svg>
  );
};
